
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
@media (min-width: 1024px) {.idb-graphs-countries {margin: auto
  }.idb-graphs-countries {width: 75%
  }
}.idb-graphs-countries--header {margin-bottom: 0.5rem
}.idb-graphs-countries--header {display: flex
}.idb-graphs-countries--header {justify-content: center
}.idb-graphs-countries--header {background-color: var(--gray-professional-lighten-5)
}.idb-graphs-countries--header {padding-left: 1rem;padding-right: 1rem
}.idb-graphs-countries--header idb-heading {color: var(--gray-professional-darken-1)
}.idb-graphs-countries idb-stat-bar {margin-bottom: 0.5rem
}
`;